<template>
  <AppLayout :title="title">
    <DataTable
      ref="dataTable"
      title="Collaborators"
      endpoint="collaborators"
      :per-page="10"
      :sort="{ views: 'desc' }"
      class="mt-6 lg:mt-12"
    >
      <template v-slot:buttons>
        <Button type="primary" @click="newCollaborator">NEW COLLABORATOR</Button>
      </template>

      <template v-slot:rows="rows">
        <DataTableRow v-for="(row, i) in rows" :key="i" :row="row">
          <DataTableColumn title="Name" sortable="name">
            <router-link :to="{ name: 'collaborators.view', params: { id: row.id } }">{{ row.name }}</router-link>
          </DataTableColumn>
          <DataTableColumn title="Content Experiences">
            <span v-if="row.extended_content_experiences_count">{{
              row.extended_content_experiences_count | number
            }}</span>
            <span v-else class="text-supplement">-</span>
          </DataTableColumn>
          <DataTableColumn title="Newest Content Experience Version">
            <span v-if="row.extended_collection_versions_max_created_at">
              {{ row.extended_collection_versions_max_created_at | datetime }}
            </span>
            <span v-else class="text-supplement">-</span>
          </DataTableColumn>
          <DataTableColumn title="Logo">
            <BooleanIndicator :value="!!row.logo" />
          </DataTableColumn>
          <template v-slot:actions>
            <Dropdown icon="ellipsis-v" class="flip-menu">
              <DropdownLink icon="pencil" @click="editCollaborator(row)">Edit</DropdownLink>
              <DropdownLink icon="trash" @click="deleteCollaborator(row)">Delete</DropdownLink>
            </Dropdown>
          </template>
        </DataTableRow>
      </template>
    </DataTable>
  </AppLayout>
</template>

<script>
import NewCollaboratorModal from "@/modals/Collaborators/NewCollaboratorModal.vue"
import EditCollaboratorModal from "@/modals/Collaborators/EditCollaboratorModal.vue"
import BooleanIndicator from "@/components/BooleanIndicator.vue"

export default {
  components: {
    BooleanIndicator
  },
  metaInfo() {
    return { title: this.title }
  },
  data: () => ({
    title: "Collaborators"
  }),
  methods: {
    async newCollaborator() {
      if (await this.$modal.show(NewCollaboratorModal)) {
        this.$refs.dataTable.reload()
      }
    },
    async editCollaborator(row) {
      if (await this.$modal.show(EditCollaboratorModal, { endpoint: `collaborators/${row.id}` })) {
        this.$refs.dataTable.reload()
      }
    },
    async deleteCollaborator(row) {
      if (
        await this.$modal.confirm({
          type: "danger",
          message: `Are you sure you want to delete **${row.name}**?`,
          buttonText: "Delete"
        })
      ) {
        if (await this.$api.delete(`collaborators/${row.id}`)) {
          this.$notification.success(`Collaborator **${row.name}** successfully deleted.`)
          this.$refs.dataTable.reload()
        }
      }
    }
  }
}
</script>
